// Redux Helper classes if you need to store the A/B test in the Store.
// Add the abTestReducer to your Store's reducers.
// Dispatch the receiveABTest with the request result:
//   getABTest('test_name')
//     .then(r => r.json())
//     .then(payload => dispatch(receiveABTest(payload)))
const RECEIVE_AB_TEST = "abTestUtils/RECEIVE_AB_TEST";
export const abTestReducer = (state = {}, action): ABTests => {
  switch (action.type) {
    case RECEIVE_AB_TEST:
      return { ...state, ...action.payload.abTest };

    default:
      return state;
  }
};
export const receiveABTest = (abTest) => ({
  type: RECEIVE_AB_TEST,
  payload: {
    abTest,
  },
});
